import React, { useState } from 'react';
import classnames from 'classnames';
import Modal from 'scy/Modal';
import { LightBackground } from 'scy/Background';
import { AccentH5 } from 'scy/text';
import { accent } from 'scy/text/styles.mod.scss';
import CheersIcon from 'images/icons/cheers-glasses.svg?react-svg';
import { PrimaryButton } from 'scy/buttons';
import { width100 } from 'scy/utils.mod.scss';
import styles from './ThankYouModal.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';

export default function ContactModal({
  isOpen,
  handleClose,
  defaultValue,
  handleSubmit
}) {
  const [note, setNote] = useState(defaultValue || '');
  const maxLength = 140;
  const length = note.length;

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <LightBackground className={styles.background}>
        <div className={classnames(margin.md, accent)}>
          <CheersIcon width={60} height={36} />
        </div>
        <AccentH5 uppercase className={styles.heading}>
          Send a Note
        </AccentH5>
        <p className={styles.subheading}>
          Your note will be sent via text once your gift has been delivered.
        </p>

        <form
          onSubmit={e => {
            e.preventDefault();
            return handleSubmit(note);
          }}
          className={classnames(
            padding.tablet_left_sm,
            padding.tablet_right_sm
          )}
        >
          <div
            className={classnames(
              padding.tablet_left_sm,
              padding.tablet_right_sm
            )}
          >
            <textarea
              placeholder="Thanks for the gift..."
              autoFocus
              className={styles.textarea}
              value={note}
              onChange={e => setNote(e.target.value)}
              maxLength={maxLength}
            />
            <div className={styles.counter}>
              {length} / {maxLength}
            </div>
          </div>
          <PrimaryButton className={width100}>Save Note</PrimaryButton>
        </form>
      </LightBackground>
    </Modal>
  );
}
